/** The portal's «ما يحتاج إجراء» (docs/09 §2): what waits on the caller, within their scope. */
import { z } from "zod";
const Person = z.object({ id: z.uuid(), name: z.string() });
export const InboxResponse = z.object({
    /** Draft plans waiting for approval. */
    draftPlans: z.array(z.object({
        planId: z.uuid(),
        enrollmentId: z.uuid(),
        student: Person,
        circle: Person,
        createdAt: z.string(),
        /** The teacher who proposed the draft (B12-a), if a teacher did. */
        proposedBy: Person.nullable(),
    })),
    /** Recorded exams this caller may approve. */
    examsToApprove: z.array(z.object({
        examId: z.uuid(),
        student: Person,
        typeName: z.string(),
        score: z.number(),
        maxScore: z.number(),
        passed: z.boolean(),
        recordedAt: z.string(),
    })),
    /** Scheduled exams whose day has passed without a recorded score. */
    overdueExams: z.array(z.object({
        examId: z.uuid(),
        student: Person,
        examiner: Person,
        typeName: z.string(),
        scheduledOn: z.string(),
    })),
    /** Active circles with no current teacher. */
    circlesWithoutTeacher: z.array(z.object({ id: z.uuid(), name: z.string(), branchName: z.string() })),
    /**
     * Absences corrected to present whose effect on the plan could not be undone (the student recited since):
     * the supervisor reviews the plan (B9-a, 2026-10-18).
     */
    absenceCorrections: z.array(z.object({
        planId: z.uuid(),
        enrollmentId: z.uuid(),
        student: Person,
        circle: Person,
        date: z.string(),
        at: z.string(),
    })),
    /** Live sessions in the last 7 days that failed, expired or were missed. */
    failedSessions: z.array(z.object({ id: z.uuid(), student: Person, circle: Person, status: z.string(), at: z.string() })),
});
//# sourceMappingURL=inbox.js.map